<template>
    <div class="assembly">
         <div class="m-left"><span></span> 选择组件</div>
        <div class="select">
            <div :class="['select-item',{'active':selectIndex == index}]" v-for="(item,index) in selectList" :key="index"  @click="selectIndex = index">
                <div class="item-img">
                    <img :src="item.url" alt="" draggable="true" @dragend="dragend_fn($event)">
                </div>
                <p>{{item.name}}</p>
            </div>

         </div>
        <div class="m-left"><span></span> 编辑属性</div>
        
        <div class="style-con">
            
          
          <!-- 复合单值 -->
         <div class="style-con">
            <div class="tab-chat">
                <div><span v-for="(item,index) in tabList" :key="index" :class="[{'active':tabIndex == index}]" @click="tabIndex = index">{{item}}</span></div>
                 <p @click="previewData_fn">预览</p>
            </div>
       
             <div v-show="tabIndex == 0">
                <div class="style-item">
                  <span>日期</span>
                   <el-select v-model="timerVal" filterable  placeholder="请选择"  style="width:240px">
                        <el-option
                        v-for="item in timerList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="style-item">
                  <span>间距</span>
                   <el-input-number v-model="tongSpacing" controls-position="right"  :min="1" :max="2000" style="wdith:120px" @change="change_fn"></el-input-number>
                </div>
             </div>
             <div v-show="tabIndex == 1" class="line-data-y" style="margin-top:20px">
                <div class="direct">
                        <div class="data-type">
                            <span>应用类型：</span>
                            <el-select v-model="screenTypevalue" clearable placeholder="选择应用类型" >
								<el-option v-for="item in screenTypeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
                        </div>
                          <div class="variable-tree" :style="{'height':heights+'px'}">
                            <el-scrollbar style="height:100%;width: 100%;">
                                <el-tree
                                        class="filter-tree"
                                        :data="treeList"
                                        show-checkbox
                                        :props="defaultProps2"
                                        node-key="keyId"
                                        @check="currentChecked"
                                        ref="tree"
                                       >
                                        <span class="custom-tree-node" slot-scope="{node}" >
                                             <div v-if="routeData.kanBanType == '指定'">
                                                <img src="../../../public/static/image/elTree/1.9.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.Category && node.data.Content.Category == 'Organization'"/>

                                                    <img src="../../../public/static/image/elTree/variable.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.variableName"/>

                                                    <img src="../../../public/static/image/elTree/2.1.png" style="margin-right: 2px; position: relative;top: 1px;" 
                                                    v-if="node.data.Content.Category &&  node.data.Content.Category == 'Device'"/>
                                             </div>
                                             <div v-if="routeData.kanBanType == '通用'">
                                                  <img src="../../../public/static/image/elTree/variable.png" style="margin-right: 2px;" 
                                                    v-if="node.data.Content.Category == 'AppType'"/>

                                                    <img src="../../../public/static/image/elTree/2.1.png" style="margin-right: 2px; position: relative;top: 1px;" 
                                                    v-if="node.data.Content.Category == 'AppTypeGroup'"/>
                                             </div>
                                             <span style="padding-left: 5px;" >{{node.data.Content.Name}}</span>
                                        </span>
                                         
                                        
                                </el-tree>
                                 <!-- 看板类型为通用 -->
                            </el-scrollbar>
                          
                        </div>
                 </div>
             </div>
        
       
        
        
        </div>
       
        </div>
       
        
       
        
        
    </div>
</template>

<script>
import {previewData} from "../../api/customKanBanApi";
export default {
    // props:['routeData','progressObj'],
    props: {
        //  routeData: {
        //     type: Object,
        //     default: () => ({})
        // },
        progressObj: {
            type: Object,
            default: () => ({})
        },
        
        },
    data() {
        return {
            tabList:['样式','数据'],
             tabIndex:0,
            //组件数据
             selectList:[{
                  'name':"进度条",
                  'url':require('@/assets/customKanBan/图库/progress.png'),
                }],
             selectIndex:0,
             fontSizeList:[],
             percentage: 20,
             customColor: '#409eff',
             tongSpacing:10,
             defaultProps2: {
					children: 'ChildDatas',
					label: 'Content.Name'
				},
                treeList: [],
            treeListCopy:[],
            screenTypeData:[],
            checkedNodes:[],
            screenTypevalue:"",
             heights: document.getElementById('app').clientHeight-560,
             arrIndex:-1,
             timerList:[
                {
                    value:"DAY",
                    label:"日"
                },
                {
                    value:"MON",
                    label:"月"
                },
             ],
             timerVal:"MON",
             lastColor:"#FF5C38",
             sameColor:"#FF5C38",
             lastCompare:20,
             sameCompare:20,
             routeData:[]
        };
    },

    mounted() {
        this.routeData = this.$store.deviceStore.state.customKanBanList
      
    },
    watch:{
           //看板类型
        routeData(val){
             this.treeList =val
             console.log("treeList",val);
             this.treeListCopy = JSON.parse(JSON.stringify(this.treeList))
             this.screenTypeData = this.$store.deviceStore.state.kanBanAppTypeGroup
        },
          //筛选类型
		screenTypevalue(val){
			this.screenType_fn(val)
				// this.$refs.tree.filter(val);
		},
      progressObj(val){
          if(JSON.stringify(val) == '{}'){
             this.arrIndex = -1
              this.$refs.tree.setCheckedKeys([]);
            return
          }
          var data = JSON.parse(JSON.stringify(val))
          if(JSON.stringify(data.resParameter) == '{}'){
                  this.$refs.tree.setCheckedKeys([]);
               }else {
                  this.$refs.tree.setCheckedNodes(data.resParameter.resParameter[0].checkedNodes);
               }
          this.arrIndex = data.arrIndex
          this.tongSpacing = (data.spacing).replace(/px/g, "")
        

      }
        
    },

    methods: {
        //拖放
        dragend_fn(e){
           var clientX = e.clientX
            var clientY = e.clientY
            var d  = {
                 'clientX':clientX, 
                 'clientY':clientY,
                 'tabIndex':6,
                 'lastCompare':20,
                 'lastColor':"#FF5C38",
                 'sameCompare':20,
                 'sameColor':"#FF5C38",
                 'spacing':this.tongSpacing+'px',
                 'resParameter':{}

            }
             this.$emit('progress_fn',d)
        },
        //点击预览
        previewData_fn(){
            console.log("预览");
            // if(this.arrIndex == -1){
            //     return
            // }
            var viArr = []
            this.checkedNodes.forEach(item => {
                viArr.push({
                    'dateType':this.timerVal,
                    'variableName':this.routeData[0].kanBanType =='指定' ? item.Content.variableName :  item.Content.Name,
                    'appType':item.Content.appType,
                })
            })
            var d = {
                "biType": this.routeData[0].kanBanType =='指定' ? 'CUSTOMIZED' :  'UNIVERSAL',
                "resParameter": [
                    {
                        "biCategory": "SINGLE_ASSORTED",
                        "resJsonPars": JSON.stringify(viArr),
                        'checkedNodes':this.checkedNodes,
                        "tag": `progress${this.arrIndex + 1}`
                    }
                ],
                "resType": 0,
                "unitId": this.routeData[0].Content.UnitId
            }
            previewData(d).then(res => {
                if(res.code == 200){
                    this.lastColor  = res.data.biViews[0].data.lastCompareValue > 0 ? '#FF5C38' : '#25D09D'
                    this.sameColor = res.data.biViews[0].data.sameCompareValue > 0 ? '#FF5C38' : '#25D09D'
                    this.lastCompare = res.data.biViews[0].data.lastCompareValue 
                    this.sameCompare = res.data.biViews[0].data.sameCompareValue 
                    this.fusingleChange(d)
                    this.$message({ showClose: true, message: '预览成功', type: 'success'})
                }else {
                     res.message ?  this.$message({ showClose: true, message:  res.message, type: 'warning'}) : this.$message({ showClose: true, message: '预览失败', type: 'warning'})
                }

            })
        },

        //改变
        change_fn(){
             var d  = {
                   'type':0,
                   'spacing':this.tongSpacing+'px' 
            }
            this.$emit('changPro_fn',d)
        },
        fusingleChange(data){
            var d = {
                   'type':1,
                   'spacing':this.tongSpacing+'px',
                   'resParameter':data,
                   'lastColor':this.lastColor,
                   'sameColor':this.sameColor,
                   'lastCompare':this.lastCompare,
                   'sameCompare':this.sameCompare,
            }
            this.$emit('changPro_fn',d)
        },
        //树形结构选中节点
			 currentChecked (nodeObj, SelectedObj) {
                
				this.checkedNodes = SelectedObj.checkedNodes

                if(this.routeData[0].kanBanType == '指定'){
                        this.checkedNodes.forEach((item,index) => {
                            if(!item.Content.hasOwnProperty('variableName')){
                                this.checkedNodes.splice(index,1)
                            }
                        })
                        this.checkedNodes.forEach((item,index) => {
                            if(item.hasOwnProperty('ChildDatas')){
                                this.checkedNodes.splice(index,1)
                            }
                        })
                 }else {
                      this.checkedNodes.forEach((item,index) => {
                            if(item.Content.Category == "AppTypeGroup"){
                                this.checkedNodes.splice(index,1)
                            }
                        })
                 }

            //    if(this.arrIndex != -1){
            //       this.fusingleChange()
            //    }
               
				

                // console.log("checkedNodes",this.checkedNodes);
                // console.log("halfCheckedNodes",this.halfCheckedNodes);

				
            },
        //类型筛选
            screenType_fn(value){
                    var a = JSON.parse(JSON.stringify(this.treeListCopy))
                    console.log("this.treeListCopy",this.treeListCopy);
                    if(value == ""){
                        this.treeList  = a 
                        return
                    }
                    if(this.routeData[0].kanBanType == '指定'){
                        var recursiveFunction = function(){
                                    const getStr = function(list){
                                        list.forEach(function(row){
                                            if(row.Content.Category == "Device"){
                                            row.ChildDatas = 	row.ChildDatas.filter(v => v.Content.Id == value)
                                            }else {
                                                if(row.ChildDatas == null){
                                                    row.ChildDatas = []
                                                }
                                                    getStr(row.ChildDatas)
                                            }
                                        })
                                    }
                                    getStr(a)
                                }
                            recursiveFunction()
                            this.treeList = a
                    }else {
                        var newArr =  a.filter(item => item.Content.id == value)
                        this.treeList = newArr
                    }
                    
                    
                },

       


      
        
       
    },
};
</script>

<style lang="scss" scoped>
.assembly{
    .m-left {
        color: #359EFF;
        display: flex;
        align-items: center;
        span {
            background-color: #359EFF;
            display: inline-block;
            width: 2px;
            height: 12px;
            margin-right: 4px;

        }
    }
    .select {
       display: flex;
       flex-wrap: wrap;
       justify-content: space-between;
       margin-bottom: 40px;
        
        .select-item {
            width: 31%;
            height: 100px;
            background-color: #000000;
            margin-top: 15px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
             transition: all 0.3s;
            border: 2px solid transparent;
            .item-img {
                width: 95%;
                height: 68px;
                margin-top: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    max-width: 95%;
                }

            }
            &.active {
                // border: 2px solid #0085FF;
                border: 2px solid aqua;

            }
     
          &:hover {
				/* 鼠标悬浮时盒子出现的阴影 */
                //    box-shadow: 0px 1px 12px 0px #cccccc;
				transform: translate(0, -5px);/* 鼠标悬浮时盒子上移10px */
			}
            p {
                color: #999999;
            }
        }
    }
      .style-con {
            .style-item {
                
                display: flex;
                align-items: center;
                margin-top: 20px;
               
                span {
                    margin-right: 20px;
                    display: inline-block;
                    width: 30px;
                     text-align: right;
                }
                p {
                    margin-left: 4px;
                    color: #999999;
                }
                 /deep/.el-input-number{
                line-height: 34px;
                width: 120px;
                }
                /deep/.el-input-number.is-controls-right .el-input-number__decrease, .el-input-number.is-controls-right .el-input-number__increase{
                    line-height: 17px;
                }
                /deep/.el-input__inner {
                    height: 36px;
                    line-height: 36px;
                }
            }
            /deep/.el-checkbox {
                margin-right: 20px;
                color: #999999;
            }
            /deep/.el-checkbox__label {
                padding-left: 4px;
            }
        }

     .tab-chat {
        // position: relative;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        p {
                margin-right: 20px;
    color: #359EFF;
        }
        span {
            display: inline-block;
            padding: 0px 8px;
            margin-right: 20px;
            color: #999999;
            height: 24px;
            border-bottom: 2px solid transparent;
            &.active{
                color: #359EFF;
                border-bottom-color: #359EFF;
            }
        }
       
       
    }
    
   



}
</style>